import { WebhooksElement } from '@swagger-api/apidom-ns-openapi-3-1';

/**
 * @public
 */
class Webhooks extends WebhooksElement {
  // OpenAPI 3.2 does not introduce changes to Webhooks.
  // This class inherits all functionality from OpenAPI 3.1.
}
export default Webhooks;